import React from "react"
import { Redirect } from "react-router-dom"

import { SsoMode } from "@cirrus/common/CustomerInfo"

import { ResetPasswordConfirmScreenContent } from "./index"
import { useCustomerInfo } from "../../../CustomerInfo"
import { useNavigationService } from "../../providers/NavigationService"

export const ResetPasswordConfirmProtectedScreenContent = () => {
  const { data } = useCustomerInfo()
  const { useParams } = useNavigationService()
  const params = useParams()

  const allowed = !!params?.token && data?.saml?.ssoMode !== SsoMode.Enforced

  return allowed ? <ResetPasswordConfirmScreenContent/> : <Redirect to="/"/>
}
